module.exports = __webpack_public_path__ + "img/Tyler.3a665bb1.png";